import { CrownOutIcon, LikeIcon, TimerIcon } from '@insta-club/components/icons';
import { Button } from '@insta-club/ui';
import Link from 'next/link';
import { cloneElement, isValidElement } from 'react';

interface ProgramAlertBoxProps {
    title: string;
    icon: React.ReactNode;
    link?: string;
    linkTitle?: string;
    description?: string;
    extra?: React.ReactNode;
}

interface ProgramAlertProps {
    alertKey: AlertKey;
    link?: string;
    linkTitle?: string;
    extra?: React.ReactNode;
}

type AlertKey =
    | 'program-request'
    | 'program-to-be-created'
    // | 'program-expired'
    | 'not-subscription'
    | 'last-subscription';

const alerts: Record<AlertKey, ProgramAlertBoxProps> = {
    'program-request': {
        title: 'درخواست برنامه‌اتو نهایی کن !⏳',
        icon: <LikeIcon />,
        description:
            'فقط کافیه روی دکمه زیر بزنی تا ما بر اساس هدفت در اینستاگرام، برات یه برنامه‌ی دو هفته‌ای بسازیم.',
        linkTitle: 'تکمیل درخواست برنامه'
    },
    'program-to-be-created': {
        title: 'برنامه شما در حال آماده سازی است...',
        icon: <TimerIcon />,
        description:
            'درخواست شما با موفقیت ثبت شد و پس از حدودا 48 ساعت برنامه اختصاصی پیج شما توسط کارشناس های ما طراحی و در اختیار شما قرار خواهد گرفت.'
    },
    // 'program-expired': {
    //     title: 'وقت یک برنامه ریزیه جدیده !🔥',
    //     icon: <TimerIcon />,
    //     description:
    //         'دو هفته‌ی فوق‌العاده پشت سر گذاشتی! حالا وقتشه الگوریتم دوباره بر اساس عملکردت، برنامه‌ی جدید بسازه تا رشدت متوقف نشه.',
    //     linkTitle: 'ثبت درخواست'
    // },
    'not-subscription': {
        title: 'خرید اشتراک ویژه',
        icon: <CrownOutIcon />,
        description: 'برای استفاده از تمام امکانات اختصاصی اینستا کلاب اشتراک ویژه را خریداری و فعال نمائید.',
        link: '/subscription',
        linkTitle: 'خرید اشتراک ویژه'
    },
    'last-subscription': {
        title: 'تمدید اشتراک ویژه',
        icon: <CrownOutIcon />,
        description:
            'اعتبار اشتراک ویژه اکانت شما به پایان رسیده است, برای استفاده مجدد از امکانات اینستا کلاب نسبت به خرید و فعال سازی اشتراک ویژه اقدام کنید.',
        link: '/subscription',
        linkTitle: 'تمدید اشتراک'
    }
};

const ProgramAlert: React.FC<ProgramAlertProps> = ({ alertKey, link, linkTitle, extra }) => {
    const alertConfig = alerts[alertKey];

    if (!alertConfig) {
        return null;
    }

    return (
        <ProgramAlertBox
            {...alertConfig}
            link={link !== undefined ? link : alertConfig.link}
            linkTitle={linkTitle !== undefined ? linkTitle : alertConfig.linkTitle}
            extra={extra !== undefined ? extra : alertConfig.extra}
        />
    );
};

export const ProgramAlertBox: React.FC<ProgramAlertBoxProps> = ({
    title,
    icon,
    description,
    link,
    linkTitle,
    extra
}) => {
    const iconWithSize = isValidElement(icon)
        ? cloneElement(icon as React.ReactElement<React.SVGProps<SVGSVGElement>>, {
              width: 42,
              height: 42,
              className: 'absolute-center text-primary-500'
          })
        : icon;

    return (
        <div className='shadow-card flex flex-col items-center gap-8 rounded-2xl px-5 py-10'>
            <div className='relative h-24 w-24'>
                <div className='bg-primary-100/60 absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-full' />
                <div className='bg-primary-200/55 absolute top-1/2 left-1/2 h-3/4 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-full' />

                {iconWithSize}

                <div className='bg-primary-200 absolute top-0 -left-5 h-3 w-3 rounded-full' />
                <div className='absolute -top-4 left-4 h-2 w-2 rounded-full bg-yellow-200' />
                <div className='bg-secondary-200 absolute -right-4 bottom-5 h-1.5 w-1.5 rounded-full' />
                <div className='absolute top-1/2 -left-3 h-1 w-1 rounded-full bg-blue-200' />
            </div>

            <div className='space-y-3 text-center'>
                <h6 className='text-base font-bold text-gray-800'>{title}</h6>
                {description && <p className='text-sm font-normal text-gray-500'>{description}</p>}
            </div>

            {link && (
                <Link href={link} className='w-full'>
                    <Button fullWidth>{linkTitle || 'Learn More'}</Button>
                </Link>
            )}

            {extra && <div className='w-full'>{extra}</div>}
        </div>
    );
};

export default ProgramAlert;

